import { get } from 'lodash';
import styles from './index.less';

export const DataColumns = [
  {
    title: 'Name',
    dataKey: 'name',
    key: 'name',
    width: 350,
    sortable: true,
    resizable: true,
  },
  {
    title: 'Service Type',
    dataKey: 'partnerName',
    key: 'partnerName',
    width: 350,
    sortable: true,
    resizable: true,
  },
  {
    title: 'Updated on',
    dataKey: 'updatedAt',
    key: 'updatedAt',
    width: 200,
    sortable: true,
    resizable: true,
  },
  {
    title: 'Status',
    dataKey: 'status',
    key: 'status',
    width: 150,
    sortable: true,
    resizable: true,
  },
  {
    title: 'Alert Type',
    dataKey: 'alertType',
    key: 'alertType',
    width: 150,
    sortable: true,
    resizable: true,
  },
];

export const getItems = (state) => {
  let itemList: any[] = [];
  if (state === 1) {
    itemList = [{ key: 'edit', label: 'Edit' },
      { key: 'enable', label: 'Enable' },
      { key: 'delete', label: 'Delete' },
    ];
  } else {
    itemList = [{ key: 'edit', label: 'Edit' },
      { key: 'disable', label: 'Disable' },
      { key: 'delete', label: 'Delete' },
    ];
  }
  return itemList;
};

export const displayMessage = (state) => {
  let statement = '';
  switch (state) {
  case 0: {
    statement = 'Once deleted, this service will not receive any notifications.';
    break;
  }
  case 1: {
    statement = 'Once disabled, this service will not receive any notifications.';
    break;
  }
  case 2: {
    statement = 'Once enabled, this service will receive notifications.';
    break;
  }
  default: {
    statement = '';
  }
  }
  return statement;
};

export const getRowClass = ({ rowData }) => (rowData.state === 2 ? '' : styles.disabledRow);
